import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import Header from 'modules/Header';
import Footer from 'modules/Footer';

class App extends Component {
  static propTypes = {
    component: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};

    if (window.fcWidget) {
      window.fcWidget.init({
        token: '29e6e310-3819-4027-8b1e-40b568d3817c',
        host: 'https://wchat.freshchat.com',
        config: {
          hideFAQ: true,
        },
        siteId: 'Squareboard-landing',
        tags: ['customer'],
      });
    }
  }

  render() {
    const RenderedComponent = this.props.component;
    return (
      <div className="app">
        <Route
          render={props => (
            <Fragment>
              <Header key="header" {...props} />
              <RenderedComponent {...props} key="application" />
              <Footer key="footer" {...props} />
            </Fragment>
          )}
        />
      </div>
    );
  }
}

export default App;
